import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useGetQuery } from 'hooks'
import {
  Button,
  Card,
  Icon,
  PaginateTable,
  Row,
  SearchBar,
  Wrapper
} from 'components'

export const AdminPlaces = () => {
  const [term, setTerm] = useState('')
  const [page, setPage] = useState({ page: 1, limit: 5 })
  const navigate = useNavigate()

  const { data, setPath } = useGetQuery({
    url: `/admin/locations?q=&limit=${page.limit}&offset=0`
  })

  useEffect(() => {
    const t = setTimeout(() => {
      setPath(`/admin/locations?q=${encodeURIComponent(term)}&limit=${page.limit}&offset=${(page.page - 1) * page.limit}`)
    }, 600)
    return () => clearTimeout(t)
  }, [term])

  const updatePage = (newPage) => {
    setPage(newPage)
    setPath(`/admin/locations?q=${encodeURIComponent(term)}&limit=${newPage.limit}&offset=${(newPage.page - 1) * newPage.limit}`)
  }

  return (
    <Card>
      <Wrapper margin="0 0.5rem">
        <SearchBar onChange={({ target: { value } }) => setTerm(value)} />
      </Wrapper>
      <Row>
        <PaginateTable
          data={data?.locations?.rows || []}
          count={data?.locations?.count || 0}
          columns={[
            { title: 'Name', key: 'name' },
            { title: 'Tags', key: 'tags', render: (tags) => tags.length },
            {
              title: 'Actions',
              key: 'slug',
              className: 'right',
              render: (slug) => <Link to={`/admin/places/${slug}`}>edit</Link>
            }
          ]}
          addItem={() => navigate('/admin/places/new')}
          onPageChange={updatePage}
        />
      </Row>
    </Card>
  )
}
